// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"e526e8b6","375":"62ec4cbc","480":"9c47b1bc","553":"2b15a372","674":"41d01dc3","721":"10f9fa3e","890":"9fef0066","910":"c2b6ea2f"}[chunkId] + ".chunk.js";
};